import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
} from "../../helpers/Api/Index";

export const addJobApplications = (data: any) => {
    return postApi(constants.urls.JOB_APPLICATIONS_ADD, data);
};

export const editJobApplications = (data: any, id: string) => {
    return putApi(constants.urls.JOB_APPLICATIONS_EDIT + "/" + id, data);

};

export const jobApplicationsStatus = (id:any, flag:any) => {
  return putApi(constants.urls.JOB_APPLICATIONS_STATUS + "/" + id+"/"+flag, {});

};

export const getPatientlistcount = () => {
  return getApi(constants.urls.PATIENT_COUNT);
};

export const listJobApplications = (params: string = "") => {
    return getApi(constants.urls.JOB_APPLICATIONS_LIST, params);

};
export const deleteJobApplications = (id: string) => {
    return deleteApi(constants.urls.JOB_APPLICATIONS_DELETE + "/" + id+"?hard=true");
};


export const getByJobApplicationsId = (id: string) => {
    return getApi(constants.urls.JOB_APPLICATIONS_GETBYID + "/" + id);
};

export const rollbackJobApplications = (id: string) => {
  return deleteApi(constants.urls.JOB_APPLICATIONS_DROPDOWN + "/" + id);
};

// export const jobDropdown = () => {
//   return getApi(constants.urls.JOB_DROPDOWN).then((res: any) => res.map((item: any) => {
//     return {
//       id: item.id,
//       label: item.f_name + " "+ item.l_name
//     }
//   }))
// };

// export const jobDropdownHandyman = () => {
//   return getApi(constants.urls.JOB_DROPDOWN_HANDYMAN).then((res: any) => res.map((item: any) => {
//     return {
//       id: item.id,
//       label: item.f_name + " "+ item.l_name
//     }
//   }))
// };

 export const getstatus = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:0,
            label:"Inactive"
          },
          {
            id:1,
            label:"Active"
          }
        ])
      })
    })
  }

  export const getRole = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:1,
            label:"Admin"
          },
          {
            id:2,
            label:"User"
          },
        ])
      })
    })
  }
  export const jobDropdown = () => {
    return getApi(constants.urls.JOB_DROPDOWN).then((res: any) => res.map((item: any) => {
      return {
        id: item.id,
        label: item.job_title
      }
    }))
  };